import moment from 'moment';

// Function to scroll to the top of the page
export const scrollTop = () => {
  window.scrollTo(0, 0);
};

export function getUTMParameters() {
  const urlParams = new URLSearchParams(window.location.search);
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content','gcl_id','irclickid'];

  const utmValues = {};

  utmKeys.forEach((key) => {
    if (urlParams.has(key)) {
      utmValues[key] = urlParams.get(key);
    } else {
      utmValues[key] = null;
    }
  });

  const allValuesNull = utmKeys.every((key) => utmValues[key] === null);
  return allValuesNull ? null : utmValues;
}

export const getQueryDataElevateUser = (query,platform,forward_user_data,csrfToken)=>{
  const formData = new FormData();
  formData.append('query',query);
  formData.append('source', platform);
  formData.append('forward_user_data', forward_user_data);
  return fetch(process.env.REACT_APP_ELEVATE_USER_GRAPHQL_URL,{
      method: 'POST',
      body:formData,
      headers: {
        "X-CSRFToken":csrfToken,
      },
      credentials:process.env.REACT_APP_CREDENTIAL_TYPE     
  })
  .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
  })
  .then((data) => {
      return data;
  })
}

export const getQueryData = (query,platform)=>{
  const formData = new FormData();
  formData.append('query',query);
  formData.append('source', platform);  
  return fetch(process.env.REACT_APP_GENAI_CONTENT,{
      method: 'POST',
      body:formData,
      credentials:"omit",      
  })
  .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
  })
  .then((data) => {
      return data;
  })
}

export const getQueryDataElevate = (query,platform,forward_user_data)=>{
  const formData = new FormData();
  formData.append('query',query);
  formData.append('source', platform);
  formData.append('forward_user_data', forward_user_data);
  return fetch(process.env.REACT_APP_ELEVATE_GRAPHQL_URL,{
      method: 'POST',
      body:formData,
      credentials:"omit",      
  })
  .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
  })
  .then((data) => {
      return data;
  })
}

export const convertDateToLocalDatetime = (date) => {
	if(date) {
		const dateTime = new Date(date);
		const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		const userLocalDateTime = dateTime.toLocaleString("en-US", {
		timeZone: userTimeZone,
		});
		return userLocalDateTime;
}}

export const convertDateInFormat = (originalDate,format)=>{
  let time = moment(originalDate).format(format);
  return time;
}

export const trimNewlines = (inputString) => {
  return inputString.replace(/\n/g, "");
}

export const submitPlatformFormData = (platform,query_json,csrfToken)=>{
  const formData = new FormData();
  formData.append('query', `
  mutation MyMutation {
      updatePlatformJsonData(
        platformName: "${platform}"
        jsonData: ${JSON.stringify(JSON.stringify(query_json))}
      ) {
        platformJsonData {
          platformData
        }
      }
    }
  ` );
  formData.append('source', 'newmarketingpages');
  console.log(platform,query_json);
  return fetch(process.env.REACT_APP_BACKCHANNEL,{
      method: 'POST',
      body:formData,
      headers: {
        "X-CSRFToken":csrfToken,
      },
      credentials:process.env.REACT_APP_CREDENTIAL_TYPE
  })
  .then((response) => {
      if (!response.ok) {
      throw new Error('Network response was not ok');
      }
      return response.json();
  })
}

export const getTimeInUTCFormat = (time)=>{
  const date = new Date(time);
  const offset = date.getTimezoneOffset(); 
  date.setMinutes(date.getMinutes() - offset - 330); 
  let stringDate = date.toISOString()
  return stringDate;
}

